export default "__VITE_ASSET__ChKeW1Ys__"